
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
import HeaderSearch from '@/components/HeaderSearch/index.vue'
import Screenfull from '@/components/Screenfull/index.vue'
import { PermissionModule } from '@/store/modules/permission'
import { dateToSeconds, getCurrentDate } from '@/utils/dateTime'
import { getEnterprise } from '@/api/universal'
import LangSelect from '@/components/LangSelect/index.vue'
import {
  getType,
  setCurrency,
  getCurrency,
  removeCurrency,
  removeProduct
} from '@/utils/cookies'
import moment from 'moment'
import momentTimezone from 'moment-timezone'

@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger,
    HeaderSearch,
    Screenfull,
    LangSelect
  }
})
export default class extends Vue {
  get language() {
    return AppModule.language
  }
  get isMobileH5() {
    return window.screen.availWidth <= 950 && window.screen.availWidth >= 310
  }
  private manager: string = PermissionModule.manager
  private date: any = getCurrentDate()
  private currentTime: any = ''
  private newZoneTime: any = ''

  private sysType: any = ''

  private timezoneList: any = {}

  private currentTimezone: number = this.date[0].getTimezoneOffset() / 60 // 获取当前浏览器（运行环境）的时区
  private timeZone: any = 0
  private newMinutes: any = 0
  private newHours: any = 0
  private timestamp: any = 0
  private timeE: any = null
  private newDate: any = 0
  private newMonth: any = 0
  private newYear: any = 0
  private interval: any = null

  // 强制刷新页面清楚缓存
  private refresh() {
    window.location.reload()
  }

  @Watch('$store.state.app.currentCurrencyType', {
    deep: true,
    immediate: true
  })
  private dateTime(newval, olval) {
    let c: any = getCurrency()
    if (newval && newval === c) {
      setCurrency(c)
    } else {
      setCurrency(newval)
    }
    clearInterval(this.timeE)
    this.timeE = setInterval(() => {
      this.getTimes(newval)
    }, 1000)
  }

  private getTimes(currency: any) {
    let currencyDateTime: any = ''
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      weekday: 'short' as const // 显式指定 weekday 类型
    }
    switch (currency) {
      case 'THB':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Bangkok',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let thb = moment.tz(this.formatDate(currencyDateTime), 'Asia/Bangkok')
        this.newZoneTime = thb.format('YYYY-MM-DD HH:mm Z')

        break
      case 'VND':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Ho_Chi_Minh',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let vnd = moment.tz(
          this.formatDate(currencyDateTime),
          'Asia/Ho_Chi_Minh'
        )
        this.newZoneTime = vnd.format('YYYY-MM-DD HH:mm Z')

        break
      case 'INR':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Kolkata',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let inr = moment.tz(this.formatDate(currencyDateTime), 'Asia/Kolkata')
        this.newZoneTime = inr.format('YYYY-MM-DD HH:mm Z')

        break
      case 'USDT':
        if (this.sysType !== 'ant') {
          currencyDateTime = new Date().toLocaleString('en-US', {
            timeZone: 'Asia/Bangkok',
            ...options
          })
          localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
          let antusdt = moment.tz(
            this.formatDate(currencyDateTime),
            'Asia/Bangkok'
          )
          this.newZoneTime = antusdt.format('YYYY-MM-DD HH:mm Z')
        } else {
          currencyDateTime = new Date().toLocaleString('en-US', {
            timeZone: 'Asia/Kolkata',
            ...options
          })
          localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
          let usdt = moment.tz(
            this.formatDate(currencyDateTime),
            'Asia/Kolkata'
          )
          this.newZoneTime = usdt.format('YYYY-MM-DD HH:mm Z')
        }

        break
      case 'IDR':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Jakarta',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let idr = moment.tz(this.formatDate(currencyDateTime), 'Asia/Jakarta')
        this.newZoneTime = idr.format('YYYY-MM-DD HH:mm Z')

        break
      case 'NGN':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Lagos',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let ngn = moment.tz(this.formatDate(currencyDateTime), 'Africa/Lagos')
        this.newZoneTime = ngn.format('YYYY-MM-DD HH:mm Z')

        break
      case 'PHP':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let php = moment.tz(this.formatDate(currencyDateTime), 'Asia/Manila')
        this.newZoneTime = php.format('YYYY-MM-DD HH:mm Z')

        break
      case 'TRX':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Bangkok',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let trx = moment.tz(this.formatDate(currencyDateTime), 'Asia/Bangkok')
        this.newZoneTime = trx.format('YYYY-MM-DD HH:mm Z')

        break
      case 'ZAR':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Johannesburg',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let zar = moment.tz(
          this.formatDate(currencyDateTime),
          'Africa/Johannesburg'
        )
        this.newZoneTime = zar.format('YYYY-MM-DD HH:mm Z')

        break
      case 'KES':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Nairobi',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let kes = moment.tz(this.formatDate(currencyDateTime), 'Africa/Nairobi')
        this.newZoneTime = kes.format('YYYY-MM-DD HH:mm Z')

        break
      case 'RM':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Kuching',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let rm = moment.tz(this.formatDate(currencyDateTime), 'Asia/Kuching')
        this.newZoneTime = rm.format('YYYY-MM-DD HH:mm Z')

        break
      case 'UGX':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Kampala',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let ugx = moment.tz(this.formatDate(currencyDateTime), 'Africa/Kampala')
        this.newZoneTime = ugx.format('YYYY-MM-DD HH:mm Z')

        break
      case 'KZT':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Aqtau',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let kzt = moment.tz(this.formatDate(currencyDateTime), 'Asia/Aqtau')
        this.newZoneTime = kzt.format('YYYY-MM-DD HH:mm Z')

        break
      case 'BDT':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Dhaka',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let bdt = moment.tz(this.formatDate(currencyDateTime), 'Asia/Dhaka')
        this.newZoneTime = bdt.format('YYYY-MM-DD HH:mm Z')

        break
      case 'USD':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Shanghai',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let usd = moment.tz(this.formatDate(currencyDateTime), 'Asia/Shanghai')
        this.newZoneTime = usd.format('YYYY-MM-DD HH:mm Z')

        break
      case 'BRL':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'America/Sao_Paulo',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let brl = moment.tz(
          this.formatDate(currencyDateTime),
          'America/Sao_Paulo'
        )
        this.newZoneTime = brl.format('YYYY-MM-DD HH:mm Z')

        break
      case 'MXN':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'America/Mexico_City',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let mxn = moment.tz(
          this.formatDate(currencyDateTime),
          'America/Mexico_City'
        )
        this.newZoneTime = mxn.format('YYYY-MM-DD HH:mm Z')

        break
      case 'COP':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'America/Bogota',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let cop = moment.tz(this.formatDate(currencyDateTime), 'America/Bogota')
        this.newZoneTime = cop.format('YYYY-MM-DD HH:mm Z')

        break
      case 'EUR':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Pacific/Pitcairn',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let eur = moment.tz(
          this.formatDate(currencyDateTime),
          'Pacific/Pitcairn'
        )
        this.newZoneTime = eur.format('YYYY-MM-DD HH:mm Z')

        break
      case 'CLP':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'America/Santiago',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let clp = moment.tz(
          this.formatDate(currencyDateTime),
          'America/Santiago'
        )
        this.newZoneTime = clp.format('YYYY-MM-DD HH:mm Z')

        break
      case 'PEN':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'America/Lima',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let pen = moment.tz(this.formatDate(currencyDateTime), 'America/Lima')
        this.newZoneTime = pen.format('YYYY-MM-DD HH:mm Z')

        break
      case 'RUB':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Europe/Moscow',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let rub = moment.tz(this.formatDate(currencyDateTime), 'Europe/Moscow')
        this.newZoneTime = rub.format('YYYY-MM-DD HH:mm Z')

        break
      case 'MYR':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Kuching',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let myr = moment.tz(this.formatDate(currencyDateTime), 'Asia/Kuching')
        this.newZoneTime = myr.format('YYYY-MM-DD HH:mm Z')

        break
      case 'AUD':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Australia/Sydney',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let aud = moment.tz(
          this.formatDate(currencyDateTime),
          'Australia/Sydney'
        )
        this.newZoneTime = aud.format('YYYY-MM-DD HH:mm Z')

        break
      case 'JPY':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Tokyo',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let jpy = moment.tz(this.formatDate(currencyDateTime), 'Asia/Tokyo')
        this.newZoneTime = jpy.format('YYYY-MM-DD HH:mm Z')

        break
      case 'CAD':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'America/Toronto',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let cad = moment.tz(
          this.formatDate(currencyDateTime),
          'America/Toronto'
        )
        this.newZoneTime = cad.format('YYYY-MM-DD HH:mm Z')

        break
      case 'GBP':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Europe/London',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let gbp = moment.tz(this.formatDate(currencyDateTime), 'Europe/London')
        this.newZoneTime = gbp.format('YYYY-MM-DD HH:mm Z')

        break
      case 'NOK':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Europe/Oslo',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let nok = moment.tz(this.formatDate(currencyDateTime), 'Europe/Oslo')
        this.newZoneTime = nok.format('YYYY-MM-DD HH:mm Z')

        break
      case 'NZD':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Pacific/Auckland',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let nzd = moment.tz(
          this.formatDate(currencyDateTime),
          'Pacific/Auckland'
        )
        this.newZoneTime = nzd.format('YYYY-MM-DD HH:mm Z')

        break
      case 'TRY':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Europe/Istanbul',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let tyr = moment.tz(
          this.formatDate(currencyDateTime),
          'Europe/Istanbul'
        )
        this.newZoneTime = tyr.format('YYYY-MM-DD HH:mm Z')

        break
      case 'KRW':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Seoul',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let krw = moment.tz(this.formatDate(currencyDateTime), 'Asia/Seoul')
        this.newZoneTime = krw.format('YYYY-MM-DD HH:mm Z')

        break

      case 'AED':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Dubai',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let aed = moment.tz(this.formatDate(currencyDateTime), 'Asia/Dubai')
        this.newZoneTime = aed.format('YYYY-MM-DD HH:mm Z')

        break

      case 'EGP':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Cairo',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let egp = moment.tz(this.formatDate(currencyDateTime), 'Africa/Cairo')
        this.newZoneTime = egp.format('YYYY-MM-DD HH:mm Z')

        break

      case 'PKR':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Karachi',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let pkr = moment.tz(this.formatDate(currencyDateTime), 'Asia/Karachi')
        this.newZoneTime = pkr.format('YYYY-MM-DD HH:mm Z')

        break

      case 'ARS':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'America/Argentina/Buenos_Aires',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let ars = moment.tz(
          this.formatDate(currencyDateTime),
          'America/Argentina/Buenos_Aires'
        )
        this.newZoneTime = ars.format('YYYY-MM-DD HH:mm Z')

        break

      case 'ZMW':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Lusaka',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let zmw = moment.tz(this.formatDate(currencyDateTime), 'Africa/Lusaka')
        this.newZoneTime = zmw.format('YYYY-MM-DD HH:mm Z')

        break

      case 'SGD':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Singapore',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let sgd = moment.tz(this.formatDate(currencyDateTime), 'Asia/Singapore')
        this.newZoneTime = sgd.format('YYYY-MM-DD HH:mm Z')

        break

      case 'TZS':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Dar_es_Salaam',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let tzs = moment.tz(
          this.formatDate(currencyDateTime),
          'Africa/Dar_es_Salaam'
        )
        this.newZoneTime = tzs.format('YYYY-MM-DD HH:mm Z')

        break

      case 'GHS':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Accra',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let ghs = moment.tz(this.formatDate(currencyDateTime), 'Africa/Accra')
        this.newZoneTime = ghs.format('YYYY-MM-DD HH:mm Z')

        break

      case 'XAF':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Douala',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let xaf = moment.tz(this.formatDate(currencyDateTime), 'Africa/Douala')
        this.newZoneTime = xaf.format('YYYY-MM-DD HH:mm Z')

        break

      case 'XOF':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Abidjan',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let xof = moment.tz(this.formatDate(currencyDateTime), 'Africa/Abidjan')
        this.newZoneTime = xof.format('YYYY-MM-DD HH:mm Z')

        break

      case 'RWF':
        currencyDateTime = new Date().toLocaleString('en-US', {
          timeZone: 'Africa/Kigali',
          ...options
        })
        localStorage.setItem('zoneTime', this.formatDate(currencyDateTime))
        let rwf = moment.tz(this.formatDate(currencyDateTime), 'Africa/Kigali')
        this.newZoneTime = rwf.format('YYYY-MM-DD HH:mm Z')

        break

      default:
        break
    }
  }

  private formatDate(dateString) {
    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = ('0' + (date.getMonth() + 1)).slice(-2)
    const day = ('0' + date.getDate()).slice(-2)
    const hours = ('0' + date.getHours()).slice(-2)
    const minutes = ('0' + date.getMinutes()).slice(-2)
    return `${year}-${month}-${day} ${hours}:${minutes}`
  }

  beforeDestroy() {
    if (this.timeE) clearInterval(this.timeE)
  }

  get sidebar() {
    return AppModule.sidebar
  }

  get device() {
    return AppModule.device
  }

  get avatar() {
    return UserModule.avatar
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }
  private async logout() {
    await UserModule.LogOut()
    await this.$router.push(`/login`)
  }
  private async returnOut() {
    removeCurrency()
    removeProduct()
    await this.$router.push(`/enterpriseApp`)
    location.reload()
  }

  private details: any = {}
  private async getDetails() {
    try {
      await getEnterprise().then((res: any) => {
        this.details = res
        res.available_currency_timezone.forEach(item => {
          this.timezoneList[item.currency] = item.timezone_offset
        })
      })
    } catch (e) {}
  }

  created() {
    this.sysType = getType()
    this.getDetails()
  }
}
